import { Dialog, Transition } from "@headlessui/react";
import axios from "axios";
import React, {
  Fragment,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import BadgeLogoIcon from "../../../Icons/BadgeLogoIcon";
import LockIcon from "../../../Icons/LockIcon";
import { XMarkIcon } from "@heroicons/react/24/outline";
import config from "../../../config";
import { useLoader } from "../../../hooks/LoaderContext";
function Badges({ isOpen = false, onClose, title, contest_id, lang }) {
  //const { showToast } = useToast();
  const cancelButtonRef = useRef(null);
  const [memberbadges, setmemberbadges] = useState({});
  const { showLoader, hideLoader } = useLoader();
  // const [ribbontext,setribbontext] = useState(null);

  // Add 'feBadgedetail' as a dependency

  // useEffect(() => {
  //     //sessionStorage.removeItem('member_'+id);
  //     //console.log(memberbadges);

  // }, [memberbadges]);

  const feBadgedetail = useCallback(async () => {
    showLoader();
    const session_member = sessionStorage.getItem("member_" + contest_id);
    if (session_member) {
      const memberDet = JSON.parse(session_member);
      try {
        let payload = {
          contest_id: contest_id,
          contest_member_id: memberDet.contest_member_id,
        };
        const res = await axios.post(
          `${config.API_URL}/get-badge-details`,
          payload
        );

        if (res.status === 200) {
          console.log(res.data.badge);
          setmemberbadges(res.data.badge);
          if (res.data.ribbon_text) {
            //setribbontext(res.data.ribbon_text);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        hideLoader();
      }
    }
  }, [contest_id,showLoader,hideLoader]);
  useEffect(() => {
    //sessionStorage.removeItem('member_'+id);
    if (isOpen) {
      feBadgedetail();
    }
  }, [isOpen, feBadgedetail]);
  //const badgeItems = Object.keys(memberbadges).map(key => memberbadges[key]);
  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all w-full max-w-3xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="flex items-center justify-between border-b pb-3">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-bold text-gray-900 flex items-center gap-3"
                    >
                      <BadgeLogoIcon className={"w-10 h-10"} />
                      <div>
                        <h2>{title}</h2>
                        <p className="text-sm font-normal text-gray-500">
                          {" "}
                          {lang?.badges_will_accumulate_points ||
                            "Badges will be unlocked as you accumulate points."}{" "}
                        </p>
                      </div>
                    </Dialog.Title>
                    <button
                      type="button"
                      className="absolute right-3 top-3 rounded-md bg-[#E5E5E5A3]  p-1 text-gray-500"
                      onClick={onClose}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon
                        className="h-5 w-5 text-black"
                        aria-hidden="true"
                      />
                    </button>
                  </div>

                  <div className="flex flex-col items-center py-8">
                    {Array.isArray(memberbadges) && memberbadges.length > 0 ? (
                      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
                        {memberbadges.map((badge, index) => {
                          return (
                            <div
                              key={index}
                              className={`primary_border_color relative flex flex-col items-center justify-center w-32 h-40 border-2 rounded-lg shadow-lg p-2 transition-all ${
                                badge.status
                                  ? "border-[#7EBAFF]"
                                  : "border-gray-200"
                              }`}
                            >
                              <div className="absolute top-0 left-0 right-0 h-1/2 bg-white rounded-t-lg" />
                              <div className="primary_light_bgcolor3 absolute bottom-0 left-0 right-0 h-1/2 bg-[#F1F8FF] rounded-b-lg" />

                              {badge?.badge_image ? (
                                <span className=" absolute top-8 left-4">
                                  <img
                                    src={badge?.badge_image}
                                    alt="no-image"
                                    className="w-[90px] h-[76px] rounded-lg"
                                  />
                                </span>
                              ) : (
                                <span className="absolute top-8 left-4">
                                  <img
                                    src="https://img.flexifunnels.com/flexicontest/badge_ribbon.svg"
                                    alt=""
                                  />
                                </span>
                              )}
                              <p className="absolute bottom-4 font-semibold text-gray-800">
                                {badge?.points} {lang?.points || "Points"}
                              </p>

                              {!badge.status && (
                                <div className="primary_light_bgcolor3 absolute inset-0 bg-white bg-opacity-[0.9] flex flex-col items-center justify-center rounded-lg">
                                  <span className="mb-2 text-gray-500 bg-white border border-gray-400 p-3 rounded-full">
                                    <LockIcon className={"w-5 h-5"} />
                                  </span>
                                  <p className="text-[11px] leading-[14px] px-1 text-center tracking-[0px] text-[#202E3A] opacity-100 font-normal">
                                    {badge?.badge_msg}
                                  </p>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div>
                        {" "}
                        {lang?.no_badges_available || "No Badges available"}
                      </div>
                    )}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default Badges;
